import React from "react";
import { KTSVG, toAbsoluteUrl } from "../../../../_metronic/helpers";
import { socialOptions } from "./fields/utils";

type SocialMediaOption = {
  id: string;
  name: string;
  icon: string;
};

type Props = {
  isOpen: boolean;
  onClose: () => void;
  onSelect: (option: SocialMediaOption) => void;
};

export default function SocialMediaModal({ isOpen, onClose, onSelect }: Props) {
  if (!isOpen) return null;

  return (
    <>
      <div className={`modal fade ${isOpen ? 'show' : ''}`} 
           style={{ display: isOpen ? 'block' : 'none' }}
           tabIndex={-1} 
           role="dialog">
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content social-media-modal-content">
            
            <div className="social-modal-header">
              <div className="social-modal-subtitle">Social Media & Online Presence</div>
              <div className="social-modal-title">Choose category</div>
            </div>
            <button className="experience-user-guests-modal__close" onClick={onClose} aria-label="Close">
              <KTSVG path='/media/svg/nobilis/closeX.svg' />
            </button>

            <div className="social-modal-options">
              {socialOptions.map((option) => (
                <div 
                  key={option.id}
                  className="social-modal-option"
                  onClick={() => {
                    onSelect(option);
                    onClose();
                  }}
                >
                  <div className="social-modal-icon-container">
                    <KTSVG
                      path={toAbsoluteUrl(option.icon)}
                      className="social-modal-icon"
                    />
                  </div>
                  <div className="social-modal-option-text">{option.name}</div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
      {isOpen && <div className="modal-backdrop fade show" onClick={onClose}></div>}
    </>
  );
}